import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "modal-body p-4 text-center" }
const _hoisted_3 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderSpinner = _resolveComponent("LoaderSpinner")!
  const _component_ModalConsulte = _resolveComponent("ModalConsulte")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loadingSave)
      ? (_openBlock(), _createBlock(_component_LoaderSpinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalConsulte, {
      ref: "modalExcluir",
      "hide-footer": true,
      "hide-header": true,
      modalWidth: "300px !important",
      tituloAcessivel: "Confirmar exclusão do registro"
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[6] || (_cache[6] = _createElementVNode("i", {
              class: "ri-alert-line h1 text-warning",
              "aria-hidden": "true"
            }, null, -1)),
            _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "h4 mt-2" }, "Atenção!", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("p", { class: "mt-3" }, "Deseja realmente excluir o registro selecionado?", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-warning my-2 mx-2",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onExcluir && _ctx.onExcluir(...args))),
              "aria-label": "Sim, excluir o registro"
            }, "Sim"),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary my-2 mx-2",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
              "aria-label": "Não excluir, voltar"
            }, "Não")
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createElementVNode("div", {
      class: _normalizeClass(['button-list', { 'button-list-fixed': _ctx.fixarBotoes }]),
      role: "group",
      "aria-label": "Ações do registro"
    }, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.showLimparInterno)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-secondary btn-action",
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onLimpar && _ctx.onLimpar(...args)), ["prevent"])),
              title: "Criar novo registro",
              "aria-label": "Criar novo registro"
            }, [...(_cache[9] || (_cache[9] = [
              _createElementVNode("i", {
                class: "uil-plus",
                "aria-hidden": "true"
              }, null, -1),
              _createElementVNode("span", { class: "btn-text" }, "Novo", -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.showSalvarInterno)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "submit",
              class: "btn btn-primary btn-action",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSalvar && _ctx.onSalvar(...args))),
              title: "Salvar alterações",
              "aria-label": "Salvar alterações"
            }, [...(_cache[10] || (_cache[10] = [
              _createElementVNode("i", {
                class: "ri-save-line",
                "aria-hidden": "true"
              }, null, -1),
              _createElementVNode("span", { class: "btn-text" }, "Salvar", -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.showPesquisarInterno)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 2,
              to: _ctx.gridViewLink,
              class: "btn btn-warning btn-action",
              title: "Pesquisar registros",
              "aria-label": "Pesquisar registros"
            }, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createElementVNode("i", {
                  class: "uil-search",
                  style: {"color":"white"},
                  "aria-hidden": "true"
                }, null, -1),
                _createElementVNode("span", {
                  class: "btn-text",
                  style: {"color":"white"}
                }, "Pesquisar", -1)
              ]))]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        (_ctx.showImprimirInterno)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              type: "button",
              class: "btn btn-info btn-action",
              onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onImprimir && _ctx.onImprimir(...args)), ["prevent"])),
              title: "Imprimir",
              "aria-label": "Imprimir"
            }, [...(_cache[12] || (_cache[12] = [
              _createElementVNode("i", {
                class: "uil-print",
                "aria-hidden": "true"
              }, null, -1),
              _createElementVNode("span", { class: "btn-text" }, "Imprimir", -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.showExcluirInterno)
          ? (_openBlock(), _createElementBlock("button", {
              key: 4,
              type: "button",
              class: "btn btn-danger btn-action",
              onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.popupExcluir && _ctx.popupExcluir(...args)), ["prevent"])),
              title: "Excluir registro",
              "aria-label": "Excluir registro"
            }, [...(_cache[13] || (_cache[13] = [
              _createElementVNode("i", {
                class: "uil-trash-alt",
                "aria-hidden": "true"
              }, null, -1),
              _createElementVNode("span", { class: "btn-text" }, "Excluir", -1)
            ]))]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ], 2)
  ]))
}